import { CommonModule, DatePipe } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AppUrlService } from './nav/app-url.service';
import { AppUiCustomizationService } from './ui/app-ui-customization.service';
import { AppSessionService } from './session/app-session.service';
import { CookieConsentService } from './session/cookie-consent.service';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { DateFormatJsPipe } from './pipes/date-format-js.pipe';
import { AppDateFormatPipe } from './pipes/app-date-format.pipe';
import { FormatSecondsPipe } from './pipes/format-seconds.pipe';
import { FormatTrackedTimePipe } from './pipes/format-tracked-time.pipe';
import { TimerToHrsMinsSecPipe } from './pipes/timer-to-hrs-mins-sec.pipe';
import { TimespanFormatPipe } from './pipes/timespan-format.pipe';
import { TooltipDisabledPipe } from './pipes/tooltip-disabled.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [
        DateFormatPipe,
        DateFormatJsPipe,
        AppDateFormatPipe,
        FormatSecondsPipe,
        FormatTrackedTimePipe,
        TimerToHrsMinsSecPipe,
        TimespanFormatPipe,
        TooltipDisabledPipe,
    ],
    exports: [
        DateFormatPipe,
        DateFormatJsPipe,
        AppDateFormatPipe,
        FormatSecondsPipe,
        FormatTrackedTimePipe,
        TimerToHrsMinsSecPipe,
        TimespanFormatPipe,
        TooltipDisabledPipe,
    ],
    providers: [DatePipe],
})
export class INTIMECommonModule {
    static forRoot(): ModuleWithProviders<INTIMECommonModule> {
        return {
            ngModule: INTIMECommonModule,
            providers: [
                AppUiCustomizationService,
                CookieConsentService,
                AppSessionService,
                AppUrlService
            ]
        };
    }
}
